module.exports = __webpack_public_path__ + "static/myconid-7e193d5deaafef874ff3d9eee42cde10.jpg";